!function(window) {
function stackedAreaChart(options) {

	options.charts.stackedArea.validateFilter()

	// bind filter events 
	var $filterWrapper = $('.iopr-data-wrapper .filter-wrapper.stacked-area').on('submit', 'form', function (ev) {
		ev.preventDefault();
		options.html.stackedArea.filterForm.find('button[type="submit"]').prop('disabled', true);
		generateStackedAreaChart();
	});

	// because filter option is disabled by default
	// we need to check dropdown change event and enable it if needed
	$filterWrapper.find('.iopr-select').on('changed.bs.select', function (e) {
		options.charts.stackedArea.validateFilter();
	});


	// handles filter submit
	function generateStackedAreaChart() {
		//show loader
		// hide previous data
		if (!options.html.stackedArea.chartData.hasClass('not-shown')) {
			options.html.stackedArea.chartData.fadeOut(function () {
				options.html.stackedArea.chartData.addClass('not-shown');
			});
		}

		// show loader
		if (options.html.stackedArea.chartLoader.hasClass('not-shown')) {
			options.html.stackedArea.chartLoader.fadeIn(function () {
				options.html.stackedArea.chartLoader.removeClass('not-shown');

				var ajaxBody = setStackedChartAjaxBody(options.html.stackedArea.filterForm);

				$.post(options.base.apiIncludeLng(), ajaxBody, function (data) {

					// DO STUFF WITH BODY CALL GOOGLE
					var dataJson = JSON.parse(data);

					// SHOW DATA
					// chart
					const series = [];
					// transform associative array of series to a normal array
					for (const key of Object.keys(dataJson.series)) {
						if (options.properties.excluded.indexOf(key.toString()) === -1) {
							series.push(dataJson.series[key]);
						}
					}

					dataJson.series = series;
					
					//set formater to display EUROS
					dataJson.tooltip.formatter = function (params) {
						let string = ``;
						for ( const line of params) {

							string += formatTooltipLabel(line);
						}
						const header = formatTooltipHeader(params);
						const returned = `${header} ${string}`;
						return returned;
					}

					options.charts.stackedArea.options = dataJson;


					if (!options.charts.stackedArea.chart) {
						// based on prepared DOM, initialize echarts instance
						options.charts.stackedArea.chart = echarts.init(options.html.stackedArea.chartData[0]);
						options.charts.stackedArea.resize = () => options.charts.stackedArea.chart.resize();
					}

					// use configuration item and data specified to show chart
					options.charts.stackedArea.chart.setOption(options.charts.stackedArea.options, true);

					// show loader
					if (!options.html.stackedArea.chartLoader.hasClass('not-shown')) {
						options.html.stackedArea.chartLoader.fadeOut(function () {
							options.html.stackedArea.chartLoader.addClass('not-shown');
							options.html.stackedArea.chartData.fadeIn(function () {
								options.html.stackedArea.chartData.removeClass('not-shown');
							});
						});
					}

				});
			});
		}

		function setStackedChartAjaxBody($form) {
			// get year
			var obj = {};
			obj['cashFlow'] = options.properties.cashFlow;
			obj['type'] = options.properties.type;
			obj['dataType'] = 'stacked-area';
			if (options.properties.type == 'month') {
				obj['period'] = $form.find('input[name="helper-period"]').val();
			}
			// because saving as value/field
			obj['parentId'] = options.properties.parent.id;
			obj['from'] = options.html.stackedArea.periodFrom.val();
			obj['to'] = options.html.stackedArea.periodTo.val();
			return obj;
		}
	}

	// diplsay of tooltip

	function formatTooltipHeader(params) {
		return '<div style="font-size: 1.2em; margin-bottom: 5px;"><b>'+params[0].name+'</b></div>';
	}

	function formatTooltipLabel(params) {
		let lbl = '';
		lbl +=  '<div style="display: table;">';
		lbl += '	<div style="display: table-row;">';
		lbl += '		<div style="display:table-cell; vertical-align:middle; padding-right: 5px;">';
		lbl += '			<div style="border-radius: 50%; width: 10px; height: 10px; background-color: '+params.color+';"></div>'
		lbl += '		</div>';
		lbl += '		<div style="display:table-cell; verical-align:middle;">';
		// lbl += `			${params.seriesName}: ${params.data[params.dataIndex]} €`;
		lbl += `			${params.seriesName}: ${params.data[1]} €`;

		lbl += '		</div>';
		lbl += '	</div>';
		lbl += '</div>';
		return lbl;
	}

	options.charts.stackedArea.generate = generateStackedAreaChart;
}


module.exports = stackedAreaChart;
window.stackedAreaChart = stackedAreaChart;
}(window);